<ng-container *transloco="let t">
  <div class="dialog-overlay">
    <section
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="descriptionId"
      cdkTrapFocus
      cdkTrapFocusAutoCapture>
      <header class="dialog-header">
        <h2 class="dialog-title" [id]="titleId">
          {{ t('lang.file_conflict_title') }}
        </h2>
        <p class="dialog-subtitle" [id]="descriptionId">
          {{
            t(
              editable
                ? 'lang.file_conflict_editable_description'
                : 'lang.file_conflict_domain_description'
            )
          }}
        </p>
      </header>

      <footer class="dialog-footer">
        @if (editable) {
          <button
            #rebaseButton
            type="button"
            class="primary-button"
            data-testid="rebase-conflict"
            [disabled]="busy"
            (click)="onRebase()">
            @if (busy) {
              <mzic-spinner />
            }
            {{ t('lang.file_conflict_rebase') | uppercase }}
          </button>
        }
        <button
          #reloadButton
          type="button"
          class="secondary-button"
          data-testid="reload-conflict"
          [disabled]="busy"
          (click)="onReload()">
          {{ t('lang.file_conflict_reload') | uppercase }}
        </button>
      </footer>
    </section>
  </div>
</ng-container>
